import { type SelectionsApi } from '@databases/selections-api';

/**
 * Extracts unique entry IDs from a cell selection.
 */
export function getSelectedEntryIdsFromCells(
  resolved: ReturnType<SelectionsApi['getResolvedSelection']>
): string[] {
  if (resolved.mode !== 'cell') {
    return [];
  }

  const uniqueEntryIds = new Set(resolved.values.map((v) => v.entryId));

  return [...uniqueEntryIds];
}

/**
 * Extracts unique field IDs from a cell selection.
 */
export function getSelectedFieldIdsFromCells(
  resolved: ReturnType<SelectionsApi['getResolvedSelection']>
): string[] {
  if (resolved.mode !== 'cell') {
    return [];
  }

  const uniqueFieldIds = new Set(resolved.values.map((v) => v.fieldId));

  return [...uniqueFieldIds];
}
